import { apiRequestProtected } from '../utils/axios'
import type { UserProfile, UpdateProfileRequest } from '../types/profile'

export const profileApi = {
  async getProfile(): Promise<UserProfile> {
    const response = await apiRequestProtected('GET', '/accounts')
    if (!response.success) {
      throw new Error(response.error?.message || 'Failed to fetch profile')
    }
    return response.data
  },

  async updateProfile(data: UpdateProfileRequest): Promise<UserProfile> {
    const response = await apiRequestProtected('POST', '/accounts', data)
    if (!response.success) {
      throw new Error(response.error?.message || 'Failed to update profile')
    }
    return response.data
  },
}
